(() => {
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.abortController = null;
      this.timer = null;
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(), 220);
      });
      this.input.addEventListener('focus', () => {
        if (this.results.innerHTML.trim()) this.results.parentElement.classList.add('is-open');
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.results.parentElement.classList.remove('is-open');
      });
    }

    async search() {
      const query = this.input.value.trim();
      if (query.length < 2) {
        this.results.innerHTML = '';
        this.results.parentElement.classList.remove('is-open');
        return;
      }
      this.abortController?.abort();
      this.abortController = new AbortController();
      const url = `${window.FrostPeak.routes.predictiveSearch}?q=${encodeURIComponent(query)}&resources[type]=query,product,collection,page,article&resources[limit]=10&resources[limit_scope]=all&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title,variants.sku,variants.barcode&section_id=predictive-search`;
      try {
        const response = await fetch(url, {signal: this.abortController.signal});
        if (!response.ok) return;
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const content = doc.querySelector('[data-predictive-content]');
        this.results.innerHTML = content ? content.innerHTML : '';
        this.results.parentElement.classList.toggle('is-open', Boolean(content?.innerHTML.trim()));
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();